import * as React from 'react';
import styled, { injectGlobal } from 'styled-components';

// tslint:disable-next-line
injectGlobal`
    .conversations-mobile-messenger-active {
        overflow: visible !important;

        & > body {
            background-color: #fff !important;
            bottom: 0;
            height: 100%;
            left: 0;
            overflow: hidden;
            position: fixed;
            right: 0;
            top: 0;
            width: 100%;
        }
    }
`;

const Component: any = styled.div`
    background-color: #fff;
    bottom: 0 !important;
    left: 0 !important;
    overflow: visible;
    position: fixed;
    right: 0 !important;
    top: 0 !important;
    z-index: ${(props: any) => props.zIndex} !important;
`;

export class MobileViewport extends React.Component<any, any> {
    // private targetRef = React.createRef();
    private reference: any = null;

    constructor(props: any) {
        super(props);
        this.state = {
          scrollTop: 0,
        };

        this.scrollToTop = this.scrollToTop.bind(this);
    }

    public async componentWillMount() {
        await this.setState((state: any): any => ({ ...state, scrollTop: window.pageYOffset }));
        document.documentElement.classList.add('conversations-mobile-messenger-active');
    }

    public componentDidMount() {
        this.scrollToTop();
    }

    public componentWillUnmount() {
        document.documentElement.classList.remove('conversations-mobile-messenger-active');
        window.scrollTo(0, this.state.scrollTop);
    }

    public render(): any {
        return (
            <Component
                children={this.props.children}
                className={this.props.className}
                // note: this is the old way to handle references in both React & StyledComponents
                innerRef={(input: any) => { this.reference = input; }}
                zIndex={this.props.zIndex}
            />
        );
    }

    private scrollToTop () {
        window.scrollTo(0, 0);
        document.documentElement.scrollTo(0, 0);
        if (this.reference && this.reference.scrollHeight) {
            this.reference.scrollTo(0, 0);
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/MobileViewport/MobileViewport.tsx